import { createSlice } from '@reduxjs/toolkit';
import { UsersData } from '../../FakeData';

const initialState = {
  value: UsersData,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    addUser: (state, action) => {
      state.value.push(action.payload);
    },

    deleteUser: (state, action) => {
      state.value = state.value.filter((user) => user.id !== action.payload.id);
    },

    updateUser: (state, action) => {
      state.value.map((user) => {
        if (user.id === action.payload.id) {
          user.username = action.payload.username;
          user.age = action.payload.age;
        }
        return user;
      });
    },
  },
});
export const { addUser, deleteUser, updateUser } = userSlice.actions;

export default userSlice.reducer;

export const userSelector = (state) => state.users.value;
